import moment from 'moment';

const apiBaseUrl = process.env.NODE_ENV === 'production' ? 'https://api.tejasc.in' : 'http://16.16.16.16';
const loginPagePath = '/auth/login';
const log = (data) => {
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV) console.log(data);
};
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 8 },
    xl: { span: 4 },
    xxl: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 16 },
    lg: { span: 16 },
    xl: { span: 20 },
    xxl: { span: 6 },
  },
};
const textAreaRemoveNewline = (value) => value.trim().replace(/\r?\n|\r/g, ', ');
const removeUnwantedValuesFromObject = (obj) => {
  const newObj = {};
  Object.entries(obj).forEach((entry) => {
    const key = entry[0];
    const value = entry[1];
    if (value) newObj[key] = value;
  });
  if (Object.keys(newObj).length < 1) return null;
  return newObj;
};
const getCurrencyFormattedValue = (value) =>
  value.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
const calculatePaymentDiscountPercentage = (invoiceDate) => {
  const days = moment().diff(moment(invoiceDate, 'YYYY-MM-DD'), 'days');
  if (days <= 15) return 4;
  if (days <= 30) return 3;
  if (days <= 40) return 2;
  return 0;
};

export {
  apiBaseUrl,
  loginPagePath,
  log,
  formItemLayout,
  textAreaRemoveNewline,
  removeUnwantedValuesFromObject,
  getCurrencyFormattedValue,
  calculatePaymentDiscountPercentage,
};
